import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
import { removeAllTagsFromMarkdown } from '../../utils/markdown';
const gtmAddToCustomization = ({ model, trim, gtmBodyStyle, availabilityFlag, itemCategory, itemName }) => {
    const gtmPayload = {
        event: 'bap_event',
        bap_event: 'add_to_customization',
        item_name: itemName,
        item_category: itemCategory,
        model,
        trim: removeAllTagsFromMarkdown(trim),
        body_style: gtmBodyStyle,
        availability_flag: availabilityFlag,
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmAddToCustomization;
